import React, { useEffect, useState } from 'react';
import {
  browserName,
  deviceDetect,
  engineVersion,
  getUA,
  isMobile,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from 'react-device-detect';
import ReactGA from 'react-ga4';
import CustomModal from '../components/CustomModal';

function Unity(): JSX.Element {
  // eslint-disable-next-line global-require
  const { detect } = require('detect-browser');
  const browser = detect();
  const [firefoxWarning, displayFirefoxWarning] = useState(false);
  const [safariWarning, displaySafariWarning] = useState(false);

  console.log({ isMobile });
  console.log({ browserName });
  console.log({ osVersion });
  console.log({ osName });
  console.log({ mobileModel });
  console.log({ engineVersion });
  console.log({ mobileVendor });
  console.log({ deviceDetect });
  console.log({ getUA });
  console.log('window.innerWidth', window.innerWidth);
  console.log('window.innerHeight', window.innerHeight);

  // @ts-ignore
  const memory = navigator.deviceMemory;
  console.log(`This device has at least ${memory} GiB of RAM.`);

  // this was blocking for the customer using a laptop
  const [displayOldDeviceMessage, setDisplayOldDeviceMessage] = useState(false);
  // const [isFullscreen, setIsFullscreen] = useState(false);
  //
  // const handleSetFullscreen = (fullscreen: boolean) => {
  //   const elem = document.getElementById('root');
  //   if (screenfull.isEnabled && elem) {
  //     if (fullscreen) {
  //       screenfull
  //         .request(elem)
  //         .then(() => {
  //           // setIsFullscreen(true);
  //           console.log('fullscreenEnable Success');
  //         })
  //         .catch((err) => {
  //           console.error('fullscreenEnable Error', err);
  //         });
  //     } else {
  //       screenfull
  //         .exit()
  //         .then(() => {
  //           // setIsFullscreen(false);
  //           console.log('fullscreenDisable Success');
  //         })
  //         .catch((err) => {
  //           console.error('fullscreenDisable Error', err);
  //         });
  //     }
  //   }
  // };
  //
  // const handleToggleFullscreen = () => {
  //   const elem = document.getElementById('root');
  //   if (screenfull.isEnabled && elem) {
  //     screenfull
  //       .toggle(elem)
  //       .then(() => {
  //         // setIsFullscreen(screenfull.isFullscreen);
  //         console.log('fullscreenToggle Success');
  //       })
  //       .catch((err) => {
  //         console.error('fullscreenToggle Error', err);
  //       });
  //   }
  // };

  const handleMobileDeviceMessage = () => {
    if (isMobile) {
      // iPhone 6, 7 or 8
      if (osName === 'iOS' && parseInt(osVersion) < 13 && window.innerHeight <= 667) {
        setDisplayOldDeviceMessage(true);
      }
    }
  };

  // useMessageHandler('fullscreenEnable', () => handleSetFullscreen(true));
  // useMessageHandler('fullscreenDisable', () => handleSetFullscreen(false));
  // useMessageHandler('fullscreenToggle', () => handleToggleFullscreen());
  // useMessageHandler<{ type: 'fullscreen'; fullscreen: boolean }>('fullscreen', (event) =>
  //   handleSetFullscreen(event.fullscreen),
  // );

  useEffect(() => {
    handleMobileDeviceMessage();
  }, []);

  useEffect(() => {
    if (!displayOldDeviceMessage) {
      const buildUrl = 'Build';
      const loaderUrl = `${buildUrl}/LocalServer.loader.js`;

      const config = {
        dataUrl: `${buildUrl}/LocalServer.data`,
        frameworkUrl: `/${buildUrl}/LocalServer.framework.js`,
        codeUrl: `${buildUrl}/LocalServer.wasm`,
        streamingAssetsUrl: 'StreamingAssets',
        companyName: 'SpacesInteractive',
        productName: 'WEHI',
        productVersion: '0.1',
      };

      const container = document.getElementById('unity-container');
      const canvas = document.getElementById('unity-canvas');
      const loadingBar = document.getElementById('unity-loading-bar');
      const progressBarFull = document.getElementById('unity-progress-bar-full');

      const isCanvas = (obj: HTMLCanvasElement | HTMLElement): obj is HTMLCanvasElement =>
        obj.tagName === 'CANVAS';

      // calculating ratio dynamically.
      if (canvas) {
        if (isCanvas(canvas)) {
          canvas.width = canvas.clientWidth * window.devicePixelRatio;
          canvas.height = canvas.clientHeight * window.devicePixelRatio;
          if (canvas && canvas.style && canvas.style.width) {
            canvas.style.width = (canvas.clientWidth * window.devicePixelRatio).toString();
          }
          if (canvas && canvas.style && canvas.style.height) {
            canvas.style.height = (canvas.clientHeight * window.devicePixelRatio).toString();
          }
        }
      }

      if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        if (container) container.className = 'unity-mobile';
      } else {
        if (canvas && canvas.style && canvas.style.width) canvas.style.width = '100%';
        if (canvas && canvas.style && canvas.style.height) canvas.style.height = '100%';
      }

      if (loadingBar) loadingBar.style.display = 'block';

      const script = document.createElement('script');
      script.src = `/${loaderUrl}`;

      script.onload = () => {
        createUnityInstance(canvas, config, (data: number) => {
          if (progressBarFull) progressBarFull.style.width = `${100 * data}%`;
        })
          .then((unityInstance: any) => {
            console.log({ unityInstance });
            if (loadingBar) loadingBar.style.display = 'none';

            // class to fix the height within the experience
            if (canvas) canvas.classList.add('mobile-fix');
          })
          .catch((message: any) => {
            console.log({ message });
          });
      };
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: '/my-path' });
  }, []);

  useEffect(() => {
    // handle the case where we don't detect the browser
    if (browser) {
      // console.log("browser.name ", browser.name)
      if (browser.name === 'firefox' && !firefoxWarning) {
        displayFirefoxWarning(true);
      } else if (browser.name === 'safari' && !safariWarning) {
        displaySafariWarning(true);
      }
    }
  }, []);

  console.log({ displayOldDeviceMessage });

  // const openFullscreen = () => {
  //   try {
  //     const elem = document.getElementById('unity-container');
  //     if (elem && elem.requestFullscreen) {
  //       elem.requestFullscreen().then((res) => {
  //         console.log('requestFullscreen, ', res);
  //       });
  //       // @ts-ignore
  //     } else if (elem && elem.webkitRequestFullscreen) {
  //       // @ts-ignore
  //       elem.webkitRequestFullscreen().then((res) => {
  //         console.log('webkitRequestFullscreen, ', res);
  //       });
  //     }
  //   } catch (e) {
  //     console.log({ e });
  //   }
  // };
  //
  // useEffect(() => {
  //   if (screenfull.isEnabled) {
  //     screenfull.on('change', () => {
  //       setIsFullscreen(screenfull.isFullscreen);
  //     });
  //   }
  // });

  return (
    <>
      {displayOldDeviceMessage ? (
        <div id="unity-container" className="unity-desktop old-devices">
          <div id="unity-logo" />
          <div className="message">
            <p>
              We've detected that you're using a device that's not compatible with this platform.
            </p>
            <br />
            <p>
              So that you can make the most of our virtual experience, you'll need to jump in on
              your desktop or laptop.
            </p>
            <br />
            <p>Or please visit our website</p>
            <p>to read more about the arts</p>
            <br />
            <a href="https://www.wehi.edu.au/">WEHI</a>
          </div>
        </div>
      ) : (
        <div className="unity">
          <div id="unity-container" className="unity-desktop">
            <canvas id="unity-canvas" />
            <div id="unity-loading-bar">
              <div id="unity-logo" />
              <div id="unity-progress-bar-empty">
                <div id="unity-progress-bar-full" />
              </div>
              <div className="message">
                <p>We hope you enjoy your visit to Art of Science.</p>
                <br />
                <p>
                  As you enter the gallery, music composed by Interactive Composition students at
                  the Melbourne Conservatorium of Music should play automatically.
                </p>
                <p>
                  You may need to adjust the volume on your device. There is also a mute button
                  located at the top right of the exhibition screen.
                </p>
              </div>
            </div>
          </div>
          {/* {!isMobile && ( */}
          {/*  <button */}
          {/*    className="fullscreen" */}
          {/*    onClick={handleToggleFullscreen} */}
          {/*    type="button" */}
          {/*    id="unity-fullscreen" */}
          {/*  > */}
          {/*    {isFullscreen ? 'Windowed' : 'Fullscreen'} */}
          {/*  </button> */}
          {/* )} */}
        </div>
      )}
      <CustomModal modalStatus={firefoxWarning} handleClose={() => displayFirefoxWarning(false)}>
        <h1>WEHI - ART OF SCIENCE ONLINE EXHIBITION</h1>
        <p>
          We noticed you are using Mozilla Firefox. We recommend using Google Chrome for the best
          user experience.
        </p>
      </CustomModal>
      {/* <CustomModal modalStatus={safariWarning} handleClose={() => displaySafariWarning(false)}>
       */}
      {/*  <h1>WEHI - ART OF SCIENCE ONLINE EXHIBITION</h1> */}
      {/*  <p> */}
      {/*    You may need to allow pop-ups to get the best user experience. Visit our{' '} */}
      {/*    <a href="https://www.wehi.edu.au/news-events/art-science/troubleshooting"
      target="_blank" rel="noreferrer"> */}
      {/*      Troubleshooting page */}
      {/*    </a>{' '} */}
      {/*    for details. */}
      {/*  </p> */}
      {/* </CustomModal> */}
    </>
  );
}

export default Unity;
